module.exports = __webpack_public_path__ + "media/images/webmaster-d2e28f2a429bd8ff4f955296ce71f866.png";